import React from 'react';
import { Alert, Button } from 'react-bootstrap';

interface Props {
  errorMessage: string,
  tfaRoute: string,
  showResendEmailButton: boolean,
  resendEmail: () => void,
}

const SellerContactFormAlert: React.FC<Props> = ({
  errorMessage,
  tfaRoute,
  showResendEmailButton,
  resendEmail,
}) => {
  return (
    <Alert variant="warning">
      <p>
        {errorMessage}
        {' '}
        {tfaRoute
          && (<a href={tfaRoute}>Enable Two-Factor Authentication to remove this limit.</a>)}
      </p>
      {showResendEmailButton && (
        <div>
          <Button
            className="text-uppercase rounded-pill"
            size="sm"
            variant="primary"
            onClick={resendEmail}
          >
            Resend Email
          </Button>
        </div>
      )}
    </Alert>
  );
};

export default SellerContactFormAlert;
